angular.module('lsnBase.deprecated.models')
  .factory('PolicyModelConstants', ['LsnPolicyModelConstants', function(LsnPolicyModelConstants) {
    return LsnPolicyModelConstants;
  }])
  .factory('PolicyModel', ['LsnPolicyModelV1',
    function(LsnPolicyModelV1) {
      return LsnPolicyModelV1;
    }
  ]);